import { booking } from '@assets/icons'
import Table from '@components/table'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Booking } from '@apis'
import Row from '@components/row'
import Status from '@components/status'
import Column from '@components/column'
import { Circle } from '@commons/cards/profile/style'
import theme from '@utils/theme'
import { useModal } from '@context/ModalContext'
import SuccessAlert from '@commons/success-alert'

const ActiveBookings = ({
  user,
  providerId,
}: {
  user?: any
  providerId?: number
}) => {
  const { showModal } = useModal()
  const {
    items: bookings = [],
    loading,
    totalItems,
    totalPages,
  } = useSelector((state: RootState) => state.bookings)
  console.log(bookings, 'bookings')
  const [page, setPage] = useState<number>(1)
  const fetchBookings = async (user?: any) => {
    await Booking.list({
      state: 'bookings',
      params: {
        status: 'Booked',
        page,
        limit: 20,
        ...(user
          ? { createdBy: user.id }
          : providerId
            ? { createdBy: providerId }
            : {}),
      },
    })
      .then(() => {})
      .catch(() => {})
  }

  useEffect(() => {
    fetchBookings(user)
  }, [user, providerId])

  const columns = [
    {
      title: 'Booking Id',
      key: 'bookingId',
      render: (item: any) => <>{item.id}</>,
    },
    {
      title: 'User Detail',
      key: 'userDetail',
      render: (item: any) => {
        const person = item.infos?.contactPerson
        const initial =
          typeof person === 'string' && person.length > 0
            ? person.charAt(0).toUpperCase()
            : '?'

        return (
          <Row styleRow="align-items: center; gap: 8px">
            <Circle size={40}>{initial}</Circle>
            <Column stylecolumn="gap: 0">
              <p>{person ?? '-'}</p>
              <p>{item.infos?.contactNo ?? '-'}</p>
            </Column>
          </Row>
        )
      },
    },
    {
      title: 'Bus Provider',
      key: 'busProvider',
      render: (item: any) => (
        <>
          <p>{item.schedule.vehicle.name}</p>
          <p>{item.schedule.vehicle.number}</p>
        </>
      ),
    },
    {
      title: 'Travel Route',
      key: 'travelRoute',
      render: (item: any) => (
        <>
          <p>{item.boardingPoint}</p>
          to
          <p>{item.dropOffPoint}</p>
        </>
      ),
    },
    {
      title: 'Seat Detail',
      key: 'seatDetail',
      render: (item: any) => {
        // Group seats into rows of 2
        const rows: any[] = []
        const seatsPerRow = 2
        for (let i = 0; i < item.bookingSeats.length; i += seatsPerRow) {
          rows.push(item.bookingSeats.slice(i, i + seatsPerRow))
        }

        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '10px',
                borderRadius: '12px',
                padding: '12px',
              }}
            >
              {rows.map((row, rowIndex) => (
                <div
                  key={rowIndex}
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '12px', // space between seats
                  }}
                >
                  {row.map((seat: any) => (
                    <div
                      key={seat.id}
                      style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '6px',
                        backgroundColor: theme.colors.primaryLight || '#e0f0ff',
                        color: theme.colors.primary,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontSize: '12px',
                        fontWeight: 500,
                        padding: '2px',
                      }}
                    >
                      <span>{seat.seat}</span>
                      <span
                        style={{
                          fontSize: '8px',
                          color: theme.colors.primaryDark,
                        }}
                      >
                        {seat.type}
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        )
      },
    },
    {
      title: 'Travel Date',
      key: 'travelDate',
      render: (item: any) => <>{item.date}</>,
    },
    {
      title: 'Total Fare',
      key: 'totalFare',
      render: (item: any) => <>Rs. {item.schedule.price}</>,
    },
    {
      title: 'Travel Status',
      key: 'travelStatus',
      render: (item: any) => {
        // if schedule exists
        if (item.schedule) {
          const now = new Date()
          const departureDateTime = new Date(
            `${item.schedule.startDate}T${item.schedule.departureTime}`,
          )

          // If current time is after departure time → Departed
          const status = now >= departureDateTime ? 'Departed' : 'Scheduled'

          return <Status item={{ status }} />
        }

        // fallback if no schedule
        return <Status item={{ status: item.status }} />
      },
    },
  ]

  return (
    <Table
      loading={loading}
      columns={columns}
      text="Active Bookings"
      icon={booking}
      data={bookings}
      hasExportButton={true}
      savedTitle={'activebookings.pdf'}
      totalPages={totalPages}
      totalItems={totalItems}
      itemsPerPage={20}
      onPageChange={setPage}
      onRowClick={(item) => {
        showModal(<SuccessAlert item={item} />)
      }}
    />
  )
}

export default ActiveBookings
